module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-header cell grid row middle"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "2.5rem"
    },
    attrs: {
      "src": require("src/assets/jpex-inverse.svg")
    }
  })])], 1), _vm._v(" "), _c('ul', {
    staticClass: "links cell grid grow"
  }, _vm._l((_vm.links), function(link) {
    return _c('li', {
      staticClass: "cell"
    }, [_c('router-link', {
      attrs: {
        "to": link.path
      }
    }, [_vm._v("\n        " + _vm._s(link.name) + "\n      ")])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-17d7f064"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/header.vue
// module id = 58
// module chunks = 0